module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<section class="column right blue">\n    <header>\n        <button type="button" class="btn btn-link btn-lg pull-left back_btn">\n            <i class="fa fa-chevron-left"></i>\n        </button>\n        <button type="button" class="btn btn-link btn-lg pull-right close_btn">\n            <i class="fa fa-close"></i>\n        </button>\n\n        <h2 data-l10n-id="favorites"></h2>\n    </header>\n\n    <div class="container-fluid content sticky">\n        <div class="row sticky-header">\n            <div class="col-xs-12">\n                <div class="rg_search_input"></div>\n            </div>\n        </div>\n        <div class="row sticky-inner">\n            <div class="col-xs-12">\n                <p class="no_result hide" data-l10n-id="noResult"></p>\n                <div class="rg_themes_nav append-xs-none"></div>\n            </div>\n        </div>\n    </div>\n</section>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./js/templates/user/userFavoriteThemesColumn.ejs
// module id = 367
// module chunks = 3